import { useMemo } from "react";
import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../constants/queryKeys";
import accountService from "../../services/accountService";
import stringUtils from "../../utils/stringUtils";

const useAccountAppSites = ({
  childExternalIds,
  activeAppId,
}) => {
  // See useAccountAdminSites: `[undefined]` is a common pre-selection value, so
  // compact the list and only fire once there is at least one real id.
  const externalIds = useMemo(
    () => stringUtils.compactList(childExternalIds),
    [childExternalIds?.join(",")]
  );

  return useQuery(
    [
      queryKeys.accountSites,
      externalIds.join(","),
      activeAppId,
    ],
    () =>
      accountService.fetchAccountsForApp({
        activeAppId,
        accountExternalIds: externalIds,
      }),
    {
      enabled: externalIds.length > 0 && !!activeAppId,
      staleTime: Infinity,
    }
  );
};

export default useAccountAppSites;
